import { createEndpoint } from '@/shared/models/api';
import { ConverterRequest } from '@/app/api/morgan-thermal/converter';

export const convertEmissivity = createEndpoint<number>(({fetch}) => ({ isMetric, value }: ConverterRequest) => fetch(`/Converter/Emissivity/${isMetric}/${value}`));